export default {"src":"/_next/static/media/curation_1.b0b85e5e.gif","height":500,"width":564,"blurWidth":0,"blurHeight":0};